var _path;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgKey = function SvgKey(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 20,
    viewBox: "0 0 23 20",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0496 0.331301C17.6079 -0.110434 16.8917 -0.110434 16.45 0.331301L8.84854 7.93273C8.05038 7.56034 7.1601 7.35237 6.22123 7.35237C2.78534 7.35237 0 10.1377 0 13.5736C0 17.0095 2.78534 19.7948 6.22123 19.7948C9.65713 19.7948 12.4425 17.0095 12.4425 13.5736C12.4425 11.9029 11.7839 10.386 10.7122 9.26838L14.1392 5.84141L15.4602 7.16246C15.902 7.60419 16.6182 7.60419 17.0599 7.16246C17.5016 6.72072 17.5016 6.00453 17.0599 5.56279L15.7388 4.24175L17.2498 2.7308L20.1262 5.60715C20.5679 6.04888 21.2841 6.04888 21.7258 5.60715C22.1675 5.16541 22.1675 4.44922 21.7258 4.00748L18.0496 0.331301ZM10.1802 13.5736C10.1802 15.7601 8.40771 17.5326 6.22123 17.5326C4.03476 17.5326 2.26227 15.7601 2.26227 13.5736C2.26227 11.3871 4.03476 9.61463 6.22123 9.61463C8.40771 9.61463 10.1802 11.3871 10.1802 13.5736Z",
    fill: "#8290A2"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgKey, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/key.eac176d6.svg";
export { ForwardRef as ReactComponent };